export default __webpack_public_path__ + "static/media/mintjar_logo.43db7bc2.svg";